<script lang="ts">
  import AboutAuthor from "../common/AboutAuthor.svelte";
  import ColorSchemeCredentials from "../common/ColorSchemeCredentials.svelte";
</script>

<div>
  <AboutAuthor />
  
  <ColorSchemeCredentials />

</div>
